/* GROUP START */
import {
  callIfFn,
  plannerHistoryHelper
} from "src/components/Planner/planner/history";
import { PlannerAction } from "src/components/Planner/planner/history/planner-action";
import {ts} from "src/utils/translate"
import {
  mouseupGroup,
  recalcSwitchPNIDs
} from "src/components/Planner/planner/grouping";
import {removeDeviceFromGroup} from "src/components/Planner/planner/planner";

/* GROUP START */
export class GroupDeviceAction extends PlannerAction {
  /**
   *
   * @param {number} srcDeviceId
   * @param {number} tarDeviceId
   */
  constructor(srcDeviceId, tarDeviceId) {
    super();
    this.actionName = ts("p_do_action_grp_add", "Adding device to group");
    this.srcDeviceId = +srcDeviceId;
    this.tarDeviceId = +tarDeviceId;
  }

  execute(callback) {
    mouseupGroup(this.srcDeviceId, this.tarDeviceId, function () {
      recalcSwitchPNIDs(function () {
        callIfFn(callback, true);
      });
    }, function () {
      callIfFn(callback, false);
    });
  }

  undo(callback) {
    removeDeviceFromGroup(this.srcDeviceId, function () {
      recalcSwitchPNIDs(function () {
        callIfFn(callback, true);
      });
    }, function () {
      callIfFn(callback, false);
    });
  }

  deviceIdChanged(from, to) {
    if (this.equalAsString(this.srcDeviceId, from)) {
      this.srcDeviceId = to;
    }
    if (this.equalAsString(this.tarDeviceId, from)) {
      this.tarDeviceId = to;
    }
  }
}
export class UnGroupDeviceAction extends PlannerAction {
  /**
   *
   * @param {number} srcDeviceId
   * @param {Group[]} groups
   */
  constructor(srcDeviceId, groups) {
    super();
    this.actionName = ts("p_do_action_grp_del", "Removing device from group");
    this.srcDeviceId = +srcDeviceId;
    this.groups = groups;
  }

  execute(callback) {
    removeDeviceFromGroup(this.srcDeviceId, function () {
      recalcSwitchPNIDs(function () {
        callIfFn(callback, true);
      });
    }, function () {
      callIfFn(callback, false);
    });
  }

  undo(callback) {
    plannerHistoryHelper.placeDevIntoAllGroups(this.srcDeviceId, this.groups, 0, function (res) {
      recalcSwitchPNIDs(function () {
        callIfFn(callback, res);
      });
    });
  }

  deviceIdChanged(from, to) {
    var thisVar = this;
    if (this.equalAsString(this.srcDeviceId, from)) {
      this.srcDeviceId = to;
    }
    this.groups.forEach(function (grp) {
      grp.deviceIds.forEach(function (dId, idx) {
        if (thisVar.equalAsString(dId, from)) {
          grp.deviceIds[idx] = to;
        }
      });
    });
  }
}
/* GROUP END */
